
<template>
  <div id="content"  v-show="!loading">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <p class="buttons">
        <a v-if="$_deleteActionAllowed && entity.custom_group" class="btn btn_action btn_delete" :title="'Smazat' | translate"
           @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
          <a v-if="$_updateActionAllowed && entity.id != entity.id_parent_thematic_group && !entity.custom_group" class="btn btn_action btn_reset" :title="'Resetovat' | translate"
             @click.prevent.stop="deleteEntity" v-translate>Resetovat</a>
      </p>
        <h1>{{ entity.name }}</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section>
            <div class="left">
              <h2 v-translate>Výběr operátora</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <operator-select
                    v-model="operatorIdComputed"
                    :disabled="!allowSelectOperator"
                    :options="operatorOptions"
                >
                </operator-select>
              </div>
            </div>
          </section>
            <thematic-group-basic-form
                :entity="entity"
                :is-editable="editable"
                ref="streamprofileformref"
            ></thematic-group-basic-form>
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
              </router-link>
              <input type="submit" :value="'Uložit' | translate"
                     v-if="editable"
                     :class="['btn']"
                     @click.prevent.stop="submitForm()">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import thematicGroups from "./mixins/thematicGroups";
import detailActions from "../../../components/mixins/detail-actions"
import ThematicGroupBasicForm from "./forms/ThematicGroupBasicForm.vue";

export default {
  name: "ThematicGroupsDetail",
  components: {ThematicGroupBasicForm},
  mixins: [detailActions, thematicGroups],
  data() {
    return {
      getSelectedOperatorAfterLoad: true,
      entityName: "thematic_group"
    }
  },
  created(ThematicGroupService, OperatorService) {
    this.entityService = ThematicGroupService
    this.operatorService = OperatorService
    this.getOperators(true);
    this.createdInit().then(()=>{
      if(this.$_loggedUser_selectedOperatorId){
        this.entity.id_operator = this.$_loggedUser_selectedOperatorId;
      }
    })
  },
  computed: {
    editable() {
      return this.$_updateActionAllowed && this.operatorIdComputed != 0;
    },
    allowSelectOperator(){
      return this.$_loggedUser_canChangeOperator && this.$_updateActionAllowed && !this.entity.custom_group;
    },
    operatorIdComputed: {
      get() {
        return this.entity.id_operator == null ? '0' : this.entity.id_operator;
      },
      set(newValue) {
        return this.entity.id_operator = newValue
      }
    }
  },
  methods: {
    _afterUpdateEntityActions(data) {
      this.$router.push({name: 'thematicGroupDetail', params: {id: data.id}})
      if (this.entity.id != data.id && !this.entity.custom_group) {
        location.reload();
      }
    },
  },watch:{
     operatorIdComputed: function () {
       if (!this.loading && !this.entity.custom_group) {
         this.loading = true;
         this.entityService.getEntity(this.entity.id_parent_thematic_group, {id_operator: this.operatorIdComputed})
             .then(data => {
               this.emptyMessage()
               data[this.entityName]['id_operator'] = this.entity.id_operator;
               this.entity = data[this.entityName]
               this._afterGetEntityActions(data)
               this.loading = false;
             })
             .catch(function (error) {
               this.setErrorMessage(error['error_message'])
               if (this.moduleName) {
                 this.$router.push({name: this.moduleName})
               }
             }.bind(this))
       }
     },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/thematicGroups/ThematicGroupDetail.vue